module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "80%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "scrollable": "",
      "persistent": "",
      "content-class": "elevation-0"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl"
  }, [_c('v-card-title', [_vm._v("\n      Neue Nachricht\n      "), _c('v-spacer'), _vm._v(" "), (_vm.$vars.beta) ? _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.makeTest()
      }
    }
  }, [_vm._v("Testdatein eintragen")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-2"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "py-1 pt-3 px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "outlined": "",
      "dense": "",
      "small-chips": "",
      "chips": "",
      "deletable-chips": "",
      "clearable": "",
      "multiple": "",
      "hide-details": "",
      "name": "Gruppen",
      "items": _vm.gruppen,
      "label": "Gruppen"
    },
    on: {
      "input": _vm.checkIsSendDisabled
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('v-chip', {
          attrs: {
            "small": "",
            "label": ""
          }
        }, [_vm._v(_vm._s(_vm.kontakteAusGruppen ? _vm.kontakteAusGruppen.length : 0))])]
      },
      proxy: true
    }, {
      key: "append-outer",
      fn: function() {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("help_outline")])]
            }
          }])
        }, [_vm._v(" "), _c('v-card', {
          staticClass: "transparent",
          attrs: {
            "flat": "",
            "dark": "",
            "width": "200px"
          }
        }, [_vm._v("\n                  Kontakte aus Gruppen werden automatisch als BCC versendet. Doppelte Kontakte werden ignoriert.\n                ")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.nachricht.gruppen),
      callback: function($$v) {
        _vm.$set(_vm.nachricht, "gruppen", $$v)
      },
      expression: "nachricht.gruppen"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "outlined": "",
      "dense": "",
      "small-chips": "",
      "chips": "",
      "deletable-chips": "",
      "clearable": "",
      "multiple": "",
      "hide-details": "",
      "name": "An",
      "items": _vm.bbrbbr,
      "label": "An"
    },
    on: {
      "input": _vm.checkIsSendDisabled
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('v-chip', {
          attrs: {
            "small": "",
            "label": ""
          }
        }, [_vm._v(_vm._s(_vm.nachricht.an ? _vm.nachricht.an.length : 0))])]
      },
      proxy: true
    }, (!_vm.showcc || !_vm.showbcc) ? {
      key: "append-outer",
      fn: function() {
        return [(!_vm.showcc) ? _c('v-btn', {
          staticClass: "mt-0 pt-0",
          attrs: {
            "small": "",
            "text": ""
          },
          on: {
            "click": function($event) {
              _vm.showcc = true
            }
          }
        }, [_vm._v("CC")]) : _vm._e(), _vm._v(" "), (!_vm.showbcc) ? _c('v-btn', {
          staticClass: "mt-0 pt-0",
          attrs: {
            "small": "",
            "text": ""
          },
          on: {
            "click": function($event) {
              _vm.showbcc = true
            }
          }
        }, [_vm._v("BCC")]) : _vm._e(), _vm._v(" "), (!_vm.showcc) ? _c('v-btn', {
          staticClass: "mt-0 pt-0",
          attrs: {
            "small": "",
            "text": ""
          },
          on: {
            "click": function($event) {
              _vm.showan_adresse = true
            }
          }
        }, [_vm._v("Mailadresse")]) : _vm._e()]
      },
      proxy: true
    } : null], null, true),
    model: {
      value: (_vm.nachricht.an),
      callback: function($$v) {
        _vm.$set(_vm.nachricht, "an", $$v)
      },
      expression: "nachricht.an"
    }
  })], 1), _vm._v(" "), (_vm.showan_adresse) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-combobox', {
    attrs: {
      "outlined": "",
      "dense": "",
      "small-chips": "",
      "chips": "",
      "deletable-chips": "",
      "clearable": "",
      "multiple": "",
      "hide-details": "",
      "name": "An Mailadressen",
      "label": "An Mailadressen"
    },
    on: {
      "input": _vm.checkIsSendDisabled,
      "change": _vm.formatEmails,
      "blur": _vm.formatEmails
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('v-chip', {
          attrs: {
            "small": "",
            "label": ""
          }
        }, [_vm._v(_vm._s(_vm.nachricht.an_adresse ? _vm.nachricht.an_adresse.length : 0))])]
      },
      proxy: true
    }], null, false, 1194127780),
    model: {
      value: (_vm.nachricht.an_adresse),
      callback: function($$v) {
        _vm.$set(_vm.nachricht, "an_adresse", $$v)
      },
      expression: "nachricht.an_adresse"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showcc) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "outlined": "",
      "dense": "",
      "small-chips": "",
      "chips": "",
      "deletable-chips": "",
      "clearable": "",
      "multiple": "",
      "hide-details": "",
      "name": "CC",
      "items": _vm.bbrbbr,
      "label": "CC"
    },
    on: {
      "input": _vm.checkIsSendDisabled
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('v-chip', {
          attrs: {
            "small": "",
            "label": ""
          }
        }, [_vm._v(_vm._s(_vm.nachricht.cc ? _vm.nachricht.cc.length : 0))])]
      },
      proxy: true
    }], null, false, 2757890884),
    model: {
      value: (_vm.nachricht.cc),
      callback: function($$v) {
        _vm.$set(_vm.nachricht, "cc", $$v)
      },
      expression: "nachricht.cc"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showbcc) ? _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "outlined": "",
      "dense": "",
      "small-chips": "",
      "chips": "",
      "deletable-chips": "",
      "clearable": "",
      "multiple": "",
      "hide-details": "",
      "name": "BCC",
      "items": _vm.bbrbbr,
      "label": "Bcc"
    },
    on: {
      "input": _vm.checkIsSendDisabled
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('v-chip', {
          attrs: {
            "small": "",
            "label": ""
          }
        }, [_vm._v(_vm._s(_vm.nachricht.bc ? _vm.nachricht.bcc.length : 0))])]
      },
      proxy: true
    }], null, false, 2563283143),
    model: {
      value: (_vm.nachricht.bcc),
      callback: function($$v) {
        _vm.$set(_vm.nachricht, "bcc", $$v)
      },
      expression: "nachricht.bcc"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "label": "Betreff*"
    },
    on: {
      "input": _vm.checkIsSendDisabled
    },
    model: {
      value: (_vm.nachricht.betreff),
      callback: function($$v) {
        _vm.$set(_vm.nachricht, "betreff", $$v)
      },
      expression: "nachricht.betreff"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "items": _vm.absender,
      "label": "Absender*"
    },
    on: {
      "change": _vm.checkIsSendDisabled
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("help_outline")])]
            }
          }])
        }, [_vm._v(" "), _c('v-card', {
          staticClass: "transparent",
          attrs: {
            "flat": "",
            "dark": "",
            "width": "200px"
          }
        }, [_vm._v("\n                  Wähle hier die Position aus, von welcher du die Mail senden willst. Sollte dein Amt nicht aufgeführt\n                  sein sind keine Maildaten hinterlegt. Wende dich dann an den Admin.\n                ")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.nachricht.absenderPosition),
      callback: function($$v) {
        _vm.$set(_vm.nachricht, "absenderPosition", $$v)
      },
      expression: "nachricht.absenderPosition"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "clearable": "",
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "label": "Template",
      "items": _vm.templates
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({}, on), [_vm._v("help_outline")])]
            }
          }])
        }, [_vm._v(" "), _c('v-card', {
          staticClass: "transparent",
          attrs: {
            "flat": "",
            "dark": "",
            "width": "200px"
          }
        }, [_vm._v("\n                  Die Templates sind die Designvorlage in welche deine Mail eingebettet wird. Wenn du das Template\n                  entfernst wird ein normaler Text versendet.\n                ")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.nachricht.template),
      callback: function($$v) {
        _vm.$set(_vm.nachricht, "template", $$v)
      },
      expression: "nachricht.template"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "align-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "d-flex align-center justify-space-between pa-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-icon', [_vm._v("attach_file")]), _vm._v(" "), _c('v-sheet', {
    staticClass: "d-flex align-center flex-wrap align-content-center",
    attrs: {
      "color": "transparent",
      "max-width": "70%"
    }
  }, [_vm._l((_vm.uploadedFiles), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-2 mb-2",
      attrs: {
        "label": "",
        "small": ""
      }
    }, [_c('v-sheet', {
      staticClass: "text-truncate",
      attrs: {
        "max-width": "150",
        "color": "transparent"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (_vm.uploadStatus[index] < 100) ? _c('v-progress-circular', {
      staticClass: "ml-2",
      attrs: {
        "value": _vm.uploadStatus[index],
        "size": "20",
        "rotate": "-90",
        "color": "primary",
        "width": "3"
      }
    }) : _c('v-btn', {
      attrs: {
        "icon": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "green"
      }
    }, [_vm._v("check")])], 1)], 1)
  }), _vm._v(" "), _vm._l((_vm.attachments), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-2 mb-2",
      attrs: {
        "label": "",
        "small": ""
      }
    }, [_c('v-sheet', {
      staticClass: "text-truncate",
      attrs: {
        "max-width": "150",
        "color": "transparent"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteFile(index)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)
  })], 2), _vm._v(" "), _c('span', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "rounded": "",
      "dark": "",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.handleFileImport
    }
  }, [_vm._v("Anhang auswählen\n              ")]), _vm._v(" "), _c('input', {
    ref: "uploader",
    staticClass: "d-none",
    attrs: {
      "multiple": "",
      "type": "file"
    },
    on: {
      "change": _vm.onFileChanged
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "px-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Nachricht*",
      "auto-grow": "",
      "rows": "10",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.checkIsSendDisabled
    },
    model: {
      value: (_vm.nachricht.text),
      callback: function($$v) {
        _vm.$set(_vm.nachricht, "text", $$v)
      },
      expression: "nachricht.text"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex justify-end",
    attrs: {
      "cols": "12"
    }
  }, [_c('span', [_vm._v("Antworten auf diese Mail werden an " + _vm._s(_vm.replyToMail) + " gesendet.")])])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "mr-2",
          class: !_vm.nachricht.template ? 'grey ' : 'primary--text ',
          attrs: {
            "rounded": "",
            "text": "",
            "read-only": !_vm.nachricht.template
          },
          on: {
            "click": function($event) {
              _vm.showVorschau = true
            }
          }
        }, on), [_vm._v("Vorschau")])]
      }
    }])
  }, [_vm._v(" "), (!_vm.nachricht.template) ? _c('v-card', {
    staticClass: "transparent",
    attrs: {
      "flat": "",
      "dark": "",
      "width": "200px"
    }
  }, [(!_vm.nachricht.template) ? _c('span', [_vm._v("Es muss ein Template ausgewählt werden.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', {
          staticClass: "primary",
          attrs: {
            "rounded": "",
            "disabled": _vm.isSendDisabled
          },
          on: {
            "click": function($event) {
              return _vm.sendMail()
            }
          }
        }, [_c('v-icon', {
          staticClass: "mr-2"
        }, [_vm._v("send")]), _vm._v("Senden\n          ")], 1)]
      }
    }])
  }, [_vm._v(" "), (
    !_vm.nachricht.text ||
    !_vm.nachricht.betreff ||
    !_vm.nachricht.absenderPosition ||
    (!_vm.nachricht.an.length > 0 &&
      !_vm.nachricht.cc.length > 0 &&
      !_vm.nachricht.bcc.length > 0 &&
      !_vm.nachricht.gruppen.length > 0)
  ) ? _c('v-card', {
    staticClass: "transparent",
    attrs: {
      "flat": "",
      "dark": "",
      "width": "200px"
    }
  }, [(!_vm.nachricht.text) ? _c('span', [_vm._v("Die Nachricht darf nicht leer sein.")]) : _vm._e(), _vm._v(" "), (!_vm.nachricht.betreff) ? _c('span', [_vm._v("Der Betreff darf nicht leer sein.")]) : _vm._e(), _vm._v(" "), (!_vm.nachricht.absenderPosition) ? _c('span', [_vm._v("Es muss ein Absender ausgewählt werden.")]) : _vm._e(), _vm._v(" "), (
    !_vm.nachricht.an.length > 0 &&
    !_vm.nachricht.an_adresse.length > 0 &&
    !_vm.nachricht.cc.length > 0 &&
    !_vm.nachricht.bcc.length > 0 &&
    !_vm.nachricht.gruppen.length > 0
  ) ? _c('span', [_vm._v("Es muss mindestens ein Empfänger in \"Gruppen\", \"An\", \"CC\" oder \"BCC\" ausgewählt sein.")]) : _vm._e()]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "width": "50%",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showAPISettings),
      callback: function($$v) {
        _vm.showAPISettings = $$v
      },
      expression: "showAPISettings"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        API Settings\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showAPISettings = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-2"
  }, [_c('v-textarea', {
    attrs: {
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "rows": "6",
      "auto-grow": "",
      "label": "Eingabe zur API"
    },
    model: {
      value: (_vm.apiSettings),
      callback: function($$v) {
        _vm.apiSettings = $$v
      },
      expression: "apiSettings"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showAPISettings = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "width": "80%",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showVorschau),
      callback: function($$v) {
        _vm.showVorschau = $$v
      },
      expression: "showVorschau"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Vorschau\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showVorschau = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-2"
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-2 pl-4"
  }, [_vm._v("\n            " + _vm._s(_vm.nachricht.betreff ? _vm.nachricht.betreff : "") + "\n          ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "subtitle-2 pa-2"
  }, [_vm._v("\n            Von:\n            "), (_vm.nachricht.absenderPosition) ? _c('span', [_vm._v(_vm._s(_vm.nachricht.absenderPosition))]) : _vm._e(), _vm._v(" "), (_vm.nachricht.an) ? _c('div', {
    staticClass: "mt-1"
  }, [_vm._v("\n              An:\n              "), _vm._l((_vm.nachricht.gruppen), function(item2, index2) {
    return _c('v-chip', {
      key: index2 * 2,
      staticClass: "mr-1",
      attrs: {
        "label": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("group")])], 1), _vm._v("\n                " + _vm._s(item2) + "\n              ")], 1)
  }), _vm._v(" "), _vm._l((_vm.nachricht.an), function(item, index) {
    return _c('v-chip', {
      key: index * 2 + 1,
      staticClass: "mr-1",
      attrs: {
        "pill": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                " + _vm._s(_vm.$filters.user(item, _vm.bundesbruder)) + "\n              ")], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.nachricht.an_adresse) ? _c('div', {
    staticClass: "mt-1"
  }, [_vm._v("\n              An Mailadressen:\n              "), _vm._l((_vm.nachricht.an_adresse), function(item, index) {
    return _c('v-chip', {
      key: index * 2 + 1,
      staticClass: "mr-1",
      attrs: {
        "pill": "",
        "small": ""
      }
    }, [_vm._v("\n                " + _vm._s(item) + "\n              ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.nachricht.an_cc && _vm.nachricht.an_cc.length > 0) ? _c('div', {
    staticClass: "mt-1"
  }, [_vm._v("\n              CC:\n              "), _vm._l((_vm.nachricht.an_cc), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-1",
      attrs: {
        "pill": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                " + _vm._s(_vm.$filters.user(item, _vm.bundesbruder)) + "\n              ")], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.nachricht.an_bcc && _vm.nachricht.an_bcc.length > 0) ? _c('div', {
    staticClass: "mt-1"
  }, [_vm._v("\n              BCC:\n              "), _vm._l((_vm.nachricht.an_bcc), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-1",
      attrs: {
        "pill": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                " + _vm._s(_vm.$filters.user(item, _vm.bundesbruder)) + "\n              ")], 1)
  })], 2) : _vm._e()]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-sheet', {
    ref: "cardText",
    staticClass: "pa-4",
    staticStyle: {
      "overflow-y": "auto"
    },
    attrs: {
      "max-height": "500"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.nachrichtVorschau)
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showVorschau = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c297a55c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/submodule/dialogMailNeu.vue
// module id = 809
// module chunks = 15